<!-- 
    描述：专家申请记录详情页
-->
<template>
	<div class="filed-info-layout">
		<div class="common-top"
			 ref="formRef">
			<div class="text-right pdt10 hidden">
				<el-button type="primary"
						   class="btn-blue"
						   @click="goBack"
						   size="small">返回</el-button>
			</div>
			<div class="top-box">
				<div class="h100 left-area">
					<div class="left-box">
						<div class="booking h100">
							<p class="text-center">
								<span class="number-style activeColor">{{
                                    numObj.totalTimes
                                }}</span>次
							</p>
							<p class="text-style text-center">
								全部预约记录
							</p>
						</div>
						<div class="splitLine"></div>
						<div class="booking h100">
							<p class="text-center">
								<span class="number-style"
									  :class="{
                                        activeColor: bookState == '1'
                                    }">{{ numObj.bookings }}</span>次
							</p>
							<p class="text-style text-center">
								当前预约中
							</p>
						</div>
						<div class="splitLine"></div>
						<div class="used h100">
							<p class="text-center">
								<span class="number-style"
									  :class="{
                                        activeColor: bookState == '2'
                                    }">{{ numObj.attendances }}</span>次
							</p>
							<p class="text-style text-center">
								已到场次数
							</p>
						</div>
					</div>
				</div>
				<div class="right-area">
					<el-row>
						<el-col class="text-overflow"
								:span="3">专家姓名：</el-col>
						<el-col class="text-overflow "
								:span="5">{{
                            expertsData.sname ? expertsData.sname : '-'
                        }}</el-col>
						<el-col class="text-overflow"
								:span="3">身份证号：</el-col>
						<el-col class="text-overflow"
								:span="5">{{
                            expertsData.idCard ? expertsData.idCard : '-'
                        }}</el-col>
						<el-col class="text-overflow"
								:span="3">手机号：</el-col>
						<el-col class="text-overflow"
								:span="5">{{
                            expertsData.phone ? expertsData.phone : '-'
                        }}</el-col>
						<el-col class="text-overflow"
								:span="3">开户行：</el-col>
						<el-col class="text-overflow"
								:span="5">{{
                            expertsData.openBank ? expertsData.openBank : '-'
                        }}</el-col>
						<el-col class="text-overflow"
								:span="3">银行卡号：</el-col>
						<el-col class="text-overflow"
								:span="5">{{
                            expertsData.creditCard
                                ? expertsData.creditCard
                                : '-'
                        }}</el-col>
						<el-col class="text-overflow"
								:span="3">价格(元/次)：</el-col>
						<el-col class="text-overflow"
								:span="5">{{
                            expertsData.price ? expertsData.price : '-'
                        }}</el-col>
						<el-col class="text-overflow"
								:span="3">所属：</el-col>
						<el-col class="text-overflow"
								:span="5">{{
                            expertsData.belongingName
                                ? expertsData.belongingName
                                : '-'
                        }}</el-col>
					</el-row>
				</div>
			</div>
		</div>

		<el-row>
			<tab @change="tabChange"
				 :dataArray.sync="dataArray"
				 :value="bookState"
				 ref="tab"
				 class="tab-style"></tab>
		</el-row>
		<div class="table">
			<el-table ref="xTable"
					  :data="filterData"
					  height="100%"
					  highlight-current-row
					  border>
				<el-table-column prop="serialNo"
								 label="抽取流水号"
								 align="center"
								 show-overflow-tooltip
								 width="140"></el-table-column>
				<el-table-column prop="createDate"
								 label="抽取时间"
								 align="center"
								 width="200"></el-table-column>
				<el-table-column prop="projectName"
								 label="项目名称"
								 show-overflow-tooltip
								 header-align="center"
								 align="left"
								 min-width="140"></el-table-column>
				<el-table-column prop="companyName"
								 label="预约单位"
								 align="center"
								 show-overflow-tooltip
								 width="180"></el-table-column>
				<el-table-column prop="applyItems"
								 label="事项"
								 align="center"
								 width="120"></el-table-column>
				<el-table-column prop="evaluateAdd"
								 label="评标地点"
								 show-overflow-tooltip
								 align="center"
								 width="180"></el-table-column>
				<el-table-column prop="detailAdd"
								 label="详细地址"
								 header-align="center"
								 align="left"
								 width="260"></el-table-column>
				<el-table-column prop="useStartTime"
								 label="评标时间"
								 align="center"
								 show-overflow-tooltip
								 width="180"></el-table-column>
				<el-table-column prop="useEndTime"
								 label="结束时间"
								 align="center"
								 width="180"
								 show-overflow-tooltip></el-table-column>
				<el-table-column prop="applyState"
								 label="状态"
								 align="center"
								 width="100"
								 show-overflow-tooltip>
					<template slot-scope="scope">
						<span v-if="scope.row.replyState == 0">未回复</span>
						<span style="color:green"
							  v-else-if="scope.row.replyState == 1">参加</span>
						<span style="color:red"
							  v-else-if="scope.row.replyState == 2">不参加</span>
						<span style="color:#FF9E1B"
							  v-else-if="scope.row.replyState == 3">回复超时</span>
						<span style="color:#FF9E1B"
							  v-else-if="scope.row.replyState == 4">人数已满</span>
						<span style="color:#FF9E1B"
							  v-else-if="scope.row.replyState == 9">抽取超时</span>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="table-footer w-table-footer"
			 style="text-align:center;margin-top:5px;">
			<el-pagination @size-change="handleSizeChange"
						   @current-change="handleCurrentChange"
						   :current-page="currentPage"
						   :page-sizes="pageList"
						   :page-size="pageSize"
						   :total="total"
						   layout="total, sizes, prev, pager, next, jumper">
			</el-pagination>
		</div>
	</div>
</template>
<script>
import tab from '@/components/common/tab'
import { getRecordsDetail } from 'api/modules/expertsRecords'
import { mapState } from 'vuex'
export default {
	components: {
		tab,
	},
	props: {
		eId: {
			type: String,
			default: '',
		},
		sId: {
			type: String,
			default: '',
		},
		expertsData: {
			type: Object,
			default: '',
		},
	},

	data() {
		return {
			dataArray: [
				{ label: '全部', name: '0' },
				{ label: '预约中', name: '1' },
				{ label: '已到场', name: '2' },
			],
			filterData: [],
			bookState: '0',
			loading: false,
			//筛选框
			currentPage: 1, // 当前页码
			pageList: [10, 20, 50, 100], // 显示条数数组
			pageSize: 20, // 当前显示条数
			total: 0, // 当前总条数
			searchToggle: true,
			numObj: {},
		}
	},
	created() {
		this.getData()
	},
	methods: {
		// 返回
		goBack() {
			this.$router.push({ path: '/experts-records' })
		},

		getData() {
			let arr = {
				id: this.$route.query.id,
				current: this.currentPage,
				size: this.pageSize,
				applyState: this.bookState == '0' ? '0' : '1',
				replyState: this.bookState == '0' ? '' : '1',
				end: this.bookState == '2' ? 1 : '',
			}
			getRecordsDetail(arr).then((res) => {
				this.filterData = res.data.page.records
				this.loading = false
				this.currentPage = parseInt(res.data.page.current)
				this.total = parseInt(res.data.page.total)
				this.pageSize = parseInt(res.data.page.size)
				this.numObj = res.data.param
				// 设置回显
			})
		},

		// tab切换
		tabChange(val) {
			this.currentPage = 1
			this.bookState = val
			this.getData()
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.pageSize = val
			this.getData()
		},

		//切换当前页码
		handleCurrentChange(val) {
			this.currentPage = val
			this.getData()
		},
	},
	computed: {
		...mapState('dict', { hyslx: (state) => state.hyslx }),
		...mapState('dict', { cdrnrs: (state) => state.cdrnrs }),
		...mapState('dict', { hyspzxx: (state) => state.hyspzxx }),
	},
}
</script>
<style lang="less" scoped>
.filed-info-layout {
	height: 100%;
	.common-top {
		// padding: 20px 0 0 0;
		text-align: left;
		.top-box {
			height: 150px;
			padding: 0 10px 24px 0;
			display: flex;
		}
		.left-area {
			display: flex;
			align-items: center;
			width: 300px;
		}
		.left-box {
			width: 300px;
			height: 93px;
			background: rgb(245, 247, 253);
			border: 1px solid #abc0fa;
			border-radius: 5px;
			display: flex;
			align-items: center;
		}
		.booking,
		.used {
			width: 100px;
			height: 100%;
			padding: 10px 0;
		}
		.splitLine {
			width: 1px;
			height: 60px;
			background-color: #abc0fa;
		}
		.text-style {
			font-size: 12px;
		}
		.number-style {
			font-size: 30px;
		}
		.activeColor {
			color: #2672cc;
		}
		.right-area {
			width: 1000px;
			margin-top: 15px;
			line-height: 35px;
			margin-left: 30px;
			.el-col-5 {
				font-size: 14px;
				color: #202020;
				text-align: left;
			}
			.el-col-3 {
				text-align: right;
				color: #666;
				font-size: 14px;
			}
		}
	}
	.table {
		height: 570px;
		text-align: center;
	}
	.tip-num {
		padding: 8px 0;
		p {
			padding-left: 10px;
			border-left: 4px solid #2672cc;
		}
		span {
			color: #2672cc;
			font-size: 18px;
		}
	}
	.tab-style {
		/deep/ .el-tabs__item {
			width: 100px;
			height: 32px;
			line-height: 32px;
			text-align: center;
			background: #f0f0f0;
			border-radius: 3px 3px 0px 0px;
			color: #666;
			margin-right: 20px;
			padding: 0;
			.el-tabs__header {
				border-bottom: 1px solid #2671cc;
			}
		}
		/deep/ .el-tabs__item.is-active {
			color: #fff;
			background-color: #2671cc !important;
		}
		/deep/ .el-tabs__nav-wrap::after {
			background-color: #2671cc;
			height: 1px;
			z-index: 999;
		}
		/deep/ .el-tabs__active-bar {
			background-color: transparent;
		}
	}
}
</style>
<style lang="less">
.table {
	.el-table__empty-block {
		min-height: 433px;
		text-align: center;
		width: 100%;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
	}
	.el-table--scrollable-x .el-table__body-wrapper {
		overflow-x: auto;
		height: 440px;
	}
}
</style>
